var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-row',[_c('el-col',{attrs:{"span":20}},[_vm._v(" Passo 5 - PROPOSTA COMERCIAL ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }